const yup = require("yup");

const upload = yup.object({
  uri: yup.object().required("File upload information is a required field"),
  requirement: yup.string().required("Requirement is a required field"),
});

module.exports = {
  upload,
};
